"use client";
import React from 'react';
import { useLanguage } from '@/context/LanguageContext';

export function TranslatableTitle({ titleSq, titleEn }: { titleSq: string, titleEn: string }) {
  const { language } = useLanguage();
  return <>{language === 'en' && titleEn ? titleEn : titleSq}</>;
}

export function TranslatableDescription({ descSq, descEn, fallback }: { descSq: string, descEn: string, fallback?: string }) {
  const { language } = useLanguage();
  let content = language === 'en' && descEn ? descEn : descSq;
  
  if (!content && fallback) {
    content = fallback;
  }
  
  const contentStr = typeof content === 'string' ? content : (content ? String(content) : '');
  
  // Replace h1 with h2 to avoid multiple h1 tags on the page for SEO
  const safeContent = contentStr.replace(/<h1(.*?)>/gi, '<h2$1>').replace(/<\/h1>/gi, '</h2>');
  
  return <div dangerouslySetInnerHTML={{ __html: safeContent }} />;
}

export function TranslatableLabel({ translationKey }: { translationKey: string }) {
  const { t } = useLanguage();
  return <>{t(translationKey)}</>;
}
